import axios from 'axios';
import { Token } from './token';
import Config from '@/config';

const baseUrl = `${Config.BaseAPI}/v3/analytics`;

export default {
  getAnalytic: async function({ since, until }) {
    const url = `${baseUrl}?since=${since}&until=${until}`;

    const token = await Token.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const result = await axios.get(url, { headers });
    return result.data.record;
  }
};
